<div
  class="kl-field"
  [class.kl-field--my-3]="marginY()"
  [class.kl-field--mb-2]="marginBottom()"
  [formGroup]="formGroup()">
  @if (label()) {
    <kl-label
      [label]="label()"
      [labelDescription]="labelDescription()"
      [isRequired]="required()"
      [htmlFor]="fieldId()" />
  }

  <div class="kl-field__control text-start">
    @if (mode() === 'basic') {
      <kl-upload-file-basic
        [maxFileSize]="maxFileSize()"
        [multiple]="multiple()"
        [acceptedFileExtentions]="acceptedFileExtentions()"
        [invalidFileTypeMessageSummary]="invalidFileTypeMessageSummary()"
        [invalidFileTypeMessageDetail]="invalidTypeDetailResolved()"
        [fileNameLabel]="displayFileLabel()"
        [fileContent]="selectedContent()"
        [fileName]="selectedName() || fileName()"
        [fileType]="selectedType() || fileType()"
        (fileSelect)="onSelectedFile($event)"
        (clearRequest)="onClearFile()"
        (showFileRequest)="showFile()" />
    } @else {
      <kl-upload-file-advanced
        [maxFileSize]="maxFileSize()"
        [multiple]="multiple()"
        [acceptedFileExtentions]="acceptedFileExtentions()"
        [invalidFileTypeMessageSummary]="invalidFileTypeMessageSummary()"
        [invalidFileTypeMessageDetail]="invalidTypeDetailResolved()"
        [fileContent]="selectedContent()"
        [fileName]="selectedName() || fileName()"
        [fileType]="selectedType() || fileType()"
        [fileSize]="selectedSize()"
        (onSelectedFileEvent)="onSelectedFile($event)"
        (onClearFileEvent)="onClearFile()"
        (showFileEvent)="showFile()" />
    }
  </div>

  @if (showFieldError()) {
    <div class="kl-field__error text-start">
      @if (controlError()) {
        <span>{{ controlError() }}</span>
      }
    </div>
  }
</div>
